import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot} from '@angular/router';



@Injectable({
  providedIn: 'root'
})
export class AuthgaurdService implements CanActivate {

  constructor(private router: Router) { }

  public isAuthenticated(): boolean {
    // Check whether the token is expired and return
    // true or false
    if(window.localStorage.getItem('m_ind_token')!=undefined || window.localStorage.getItem('m_ind_token')!=null || window.localStorage.getItem('m_ind_token')!='undefined'){
      return false;
    }else{
      return true;
    }
  }

  canActivate(): boolean {

    if(window.localStorage.getItem('m_ind_token')!=undefined && window.localStorage.getItem('m_ind_token')!=null &&   window.localStorage.getItem('m_ind_token')!='undefined'  &&   window.localStorage.getItem('m_ind_token')!=''){
     
      return true;
      
    }else{
      this.router.navigate(['login']);
      return false;
    }
  }
}
